import * as React from "react";
import { Button, Dropdown } from "antd";
import type { MenuProps } from "antd";

export type TaskStatusFlowActions = {
    saveFlow: () => Promise<void>;
    cancelFlowChanges: () => Promise<void>;
    hasUnsavedChanges: boolean;
};

type Props = {
    currentTab: string;
    flowActions: TaskStatusFlowActions | null;
    isCustomMode: boolean;
    areActionsEnabled: boolean;
    showCustomizeWorkflowButton: boolean;
    actionsMenu: MenuProps;
    shouldShowMoreActionsButton: boolean;
    onOpenCustomizeWorkflow: () => void;
    onCancelEditing: () => void;
    onSaveChanges: () => void;
};

const TaskStatusesHeader: React.FC<Props> = ({
    currentTab,
    flowActions,
    isCustomMode,
    areActionsEnabled,
    showCustomizeWorkflowButton,
    actionsMenu,
    shouldShowMoreActionsButton,
    onOpenCustomizeWorkflow,
    onCancelEditing,
    onSaveChanges,
}) => {
    const canSaveFlowChanges =
        areActionsEnabled && !!flowActions?.hasUnsavedChanges;
    const shouldShowFlowSaveActions = currentTab === "2";
    const actionsContainerStyle: React.CSSProperties = {
        alignItems: "center",
        display: "flex",
        gap: 12,
        marginLeft: "auto",
        minHeight: 40,
    };

    return (
        <div className="header-wrapper">
            <div className="title-wrapper">
                <div className="header-title">Task statuses</div>
            </div>
            <div style={actionsContainerStyle}>
                {shouldShowMoreActionsButton ? (
                    <Dropdown
                        menu={actionsMenu}
                        trigger={["click"]}
                        disabled={!areActionsEnabled}
                    >
                        <Button size="large" disabled={!areActionsEnabled}>
                            More actions
                        </Button>
                    </Dropdown>
                ) : null}
                {!isCustomMode ? (
                    <>
                        {showCustomizeWorkflowButton && (
                            <Button
                                type="primary"
                                size="large"
                                disabled={!areActionsEnabled}
                                onClick={onOpenCustomizeWorkflow}
                            >
                                Customize workflow
                            </Button>
                        )}
                        {shouldShowFlowSaveActions && (
                            <Button
                                key={1}
                                data-id="submit"
                                type="primary"
                                size="large"
                                disabled={!canSaveFlowChanges}
                                onClick={onSaveChanges}
                            >
                                Save changes
                            </Button>
                        )}
                    </>
                ) : isCustomMode ? (
                    <>
                        {shouldShowFlowSaveActions &&
                            flowActions?.hasUnsavedChanges && (
                                <Button size="large" onClick={onCancelEditing}>
                                    Cancel editing
                                </Button>
                            )}
                        {shouldShowFlowSaveActions && (
                            <Button
                                key={1}
                                data-id="submit"
                                type="primary"
                                size="large"
                                disabled={!canSaveFlowChanges}
                                onClick={onSaveChanges}
                            >
                                Save changes
                            </Button>
                        )}
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default TaskStatusesHeader;
